import Vue from "vue";
import VueRouter, { Route, RouteConfig } from "vue-router";
import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";
import { $t } from "@/i18n";
import store from "@/store/index";
import Layout from "@/layout/Layout.vue";
import {userApi} from "@/api/users";
import {mailboxApi} from "@/api/mailbox";
import {templateApi} from "@/api/template";
import {sectorApi, warehouseApi} from "@/api/misc";
import {blackBoardApi} from "@/api/blackboards";
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  { path: "/login", component: Login, meta: { title: $t("Login") } },
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "/",
        name: "Startseite",
        component: Home,
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/contactSearch",
        name: "Kontaktsuche",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/contacts/Contacts.vue"
                ),
        meta: {
          permissions: ["USER", "ADMIN", "TERMIN_USER"],
        },
      },
      {
        path: "/contacts",
        name: "Kontakte",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/contacts/Contacts.vue"
          ),
        meta: {
          permissions: ["USER", "ADMIN", "TERMIN_USER"],
        },
      },
      {
        path: "/contacts/:id",
        name: "Kontakt",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/contacts/Contacts.vue"
          ),
        meta: {
          permissions: ["USER", "ADMIN", "TERMIN_USER"],
        },
      },
      {
        path: "/contacts/new",
        name: "Neuer Kontakt",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/contacts/Contacts.vue"
          ),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/contacts/:id/attachments/:attachmentId",
        name: "Dokument",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/contacts/Contacts.vue"
          ),
        meta: {
          permissions: ["USER", "ADMIN", "TERMIN_USER"],
        },
      },
      {
        path: "/contacts/:id/comments/:commentId",
        name: "Kommentare",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/contacts/Contacts.vue"
          ),
        meta: {
          permissions: ["USER", "ADMIN", "TERMIN_USER"],
        },
      },
      {
        path: "/contacts/:id/encounters/:encounterId",
        name: "Begegnung",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/contacts/Contacts.vue"
          ),
        meta: {
          permissions: ["USER", "ADMIN", "TERMIN_USER"],
        },
      },
      {
        path: "/duplicateContacts",
        name: "Dubletten",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/contacts/ContactDuplicates.vue"
          ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/flames",
        name: "Flammen",
        component: () =>
          import(/* webpackChunkName: "about" */ "@/views/flames/Flames.vue"),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/flames/:id/:taskboardId",
        name: "Flamme",
        component: () =>
          import(/* webpackChunkName: "about" */ "@/views/flames/Flames.vue"),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/flames/:id/:taskboardId/todos",
        name: "Flamme-Aufgaben",
        component: () =>
            import(/* webpackChunkName: "about" */ "@/views/flames/Flames.vue"),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/new-flame/:contactRef/:taskboardId",
        props: route => ({ step: route.query.step }),
        name: "Neue Flamme",
        component: () =>
            import(/* webpackChunkName: "about" */ "@/views/flames/Flames.vue"),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/projects",
        name: "Projekte",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/projects/Projects.vue"),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/projects/:id/:taskboardId",
        name: "Projekt",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/projects/Projects.vue"),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/projects/:id/comments/:commentId",
        name: "Projekt Kommentare",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/projects/Projects.vue"),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/emails",
        name: "E-Mails",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/email/Inbox.vue"
          ),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/voicenotes",
        name: "Sprachnotizen",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/voicenotes/VoiceNotes.vue"
          ),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/voicenotes/:id",
        name: "Sprachnotiz",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/voicenotes/VoiceNotes.vue"
          ),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/emails/:emailId",
        name: "E-Mail",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/email/Inbox.vue"
          ),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/emails/:emailId/comments/:commentId",
        name: "E-Mail Kommentar",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/email/Inbox.vue"
          ),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/templates",
        name: "Vorlagen",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/misc/EmailTemplates.vue"
          ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      //Administration
      {
        path: "/allOpenFlames",
        name: "Alle offenen Flammen",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/misc/AllOpenFlames.vue"
          ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/allArchivedFlames",
        name: "Alle archivierten Flammen",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/misc/AllArchivedFlames.vue"
                ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/allArchivedProjects",
        name: "Alle archivierten Projekte",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/misc/AllArchivedProjects.vue"
                ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/allOpenTodos",
        name: "Alle offene Aufgaben",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/misc/AllOpenTodos.vue"
                ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/users",
        name: "Benutzerverwaltung",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/users/Users.vue"),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/mailboxes",
        name: "Postfächer",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/mailboxes/Mailboxes.vue"
          ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/csvImport",
        name: "Import Kontakte",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/contacts/ContactCsvImport.vue"
          ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/products",
        name: "Produkte & Zubehör",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/products/Products.vue"
          ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/pallets",
        name: "Packstücke",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/products/Pallet.vue"
                ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/blackboards",
        name: "Blackboards",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/blackboards/BlackBoards.vue"
          ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/deliveryConditions",
        name: "Lieferkonditionen",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/misc/DeliveryConditions.vue"
          ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/paymentConditions",
        name: "Zahlungskonditionen",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/misc/PaymentConditions.vue"
          ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/sectors",
        name: "Branchen",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/misc/Sectors.vue"),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/warehouses",
        name: "Lager",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/misc/Warehouse.vue"),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/pickupcalendar",
        name: "Abholkalender",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/calendars/PickupCalendar.vue"
          ),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/appointmentcalendar",
        name: "Gesprächstermine",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/calendars/AppointmentCalendar.vue"
          ),
        meta: {
          permissions: ["USER", "ADMIN", "TERMIN_USER"],
        },
      },
      {
        path: "/ownDueFlames",
        name: "Meine Flammen",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/flames/OwnDueFlames.vue"
          ),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/ownDueProjects",
        name: "Meine Projekte",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "@/views/projects/OwnDueProjects.vue"
                ),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/ownToDos",
        name: "Meine Aufgaben",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/todos/OwnToDos.vue"
                ),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/ownUserConfiguration",
        name: "Meine Konfiguration",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "@/views/users/OwnUserConfiguration.vue"
                ),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/image-gallery",
        name: "Bildern",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/misc/ImageGallery.vue"
                ),
        meta: {
          permissions: ["USER", "ADMIN"],
        },
      },
      {
        path: "/predefinedTimeSlots",
        name: "Zeitslots für Gesprächstermine",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/misc/PredefinedTimeSlots.vue"
          ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/absenceEmail",
        name: "Abwesenheitsnotiz E-Mail",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/absencenote/AbsenceNotes.vue"
          ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/sharedDocuments",
        name: "Gemeinsame Dokumente",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/misc/SharedDocuments.vue"
                ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/todoPackages",
        name: "Aufgabenpakete",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/todoPackages/TodoPackages.vue"
                ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/emailsignature",
        name: "E-Mail Signatur",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/misc/EmailSignature.vue"
                ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/dashboards",
        name: "Dashboards",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/dashboards/Dashboard.vue"
                ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/forward-agency",
        name: "Spedition",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/misc/ForwardingAgency.vue"
                ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/steel-tubes",
        name: "Stahlwanne",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/misc/SteelTubes.vue"
                ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/wood-frames",
        name: "Holzgestell",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/misc/WoodFrames.vue"
                ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/document-classifications",
        name: "Dokumentenklassifkation",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/misc/DocumentClassifications.vue"
            ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/calc-factors",
        name: "Berechnungsfaktoren",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/misc/CalcFactors.vue"
                ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "/more-admin-menu",
        name: "More",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../layout/AdminToolList.vue"
                ),
        meta: {
          permissions: ["ADMIN"],
        },
      },
    ],
    beforeEnter(to, _, next) {
      if (store.state.auth?.loginSuccess) {
        store.state.navigation.pageTitle = to.name ?? "Unbekannt";
        if (to.name !== "Aufgabe" && to.name !== "Kontakt") {
          store.state.navigation.latestEntry = null;
          store.state.navigation.history = [];
        }

        if( store.state.user.users.length == 0 ) {
           userApi.list().then(values => {
            store.commit("user/setAllUsers", values);
            mailboxApi.list().then(values => {
              store.commit("mailbox/setAllMailboxes", values);

              templateApi.listTemplates().then(values => {
                store.commit("template/setTemplates", values);

                sectorApi.listSectors().then(values => {
                  store.commit("sector/setSectors", values);

                  warehouseApi.listWarehouses().then(values => {
                    store.commit("warehouse/setWarehouses", values);

                    blackBoardApi.list().then(async values => {
                      store.commit("taskboard/setTaskBoards", values);
                      hasAccessTo(to) ? next() : "NotAllowed";
                    })
                  })
                })
              })
            })
          })
        }else {
          hasAccessTo(to) ? next() : "NotAllowed";
        }
      } else {
        next(`/login?view=${to.fullPath}`);
      }
    },
  },
];

function hasAccessTo(route: Route): boolean {
  if (route && route.meta && route.meta.permissions) {
    return (
      route.meta.permissions.find(
        (r: string) =>
          store.state.auth.currentUser &&
          store.state.auth.currentUser.roles.filter((u) => u === r)?.length > 0
      )?.length > 0
    );
  }
  return false;
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
